function TabItem({ label, onClick, active }) {
  const handleClick = () => {
    onClick();
  };

  return (
    <button
      className={
        (active ? " bg-primary text-white" : " bg-white text-black") +
        " rounded-t-lg h-8 w-28 p-1 px-4 text-base text-center font-bold hover:shadow-lg relative"
      }
      onClick={handleClick}
    >
      {label}
      {active && (
        <span className="absolute left-[38px] bottom-[-11px]">
          <img
            src="/images/sidebar_tab_active.svg"
            alt="arrow-down"
            className="inline-block ml-2"
          />
        </span>
      )}
    </button>
  );
}

export default TabItem;
